import content from './content/what-is-cfd-trading.json';

export const whatIsCfdTradingMock = {
  name: 'what-is-cfd-trading',
  layoutType: 1,
  areasList: [
    {
      id: 'what-is-cfd-trading-main',
      componentName: 'Comp:WhatIsCfdTradingPage',
      content: JSON.stringify(content)
    }
  ]
};
